export default __webpack_public_path__ + "static/media/usdc-logo.01a55a42.png";